import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserSignUpService } from './user-sign-up.service';
import { Router } from '@angular/router';
import { customer } from '../model/customer';


@Component({
  selector: 'app-user-sign-up',
  templateUrl: './user-sign-up.component.html',
  styleUrls: ['./user-sign-up.component.css']
})
export class UserSignUpComponent implements OnInit {
 lval=true
 loginForm: FormGroup;
 signUpform:FormGroup
 errorMessage: string;

 customer:customer;
 successMessage: string;
 tryToLogin: boolean = false;
  constructor(private fb:FormBuilder,private service:UserSignUpService,private router: Router) { }

  ngOnInit(): void {
    this.createLoginForm();
    this.createSignUpForm();
    this.customer = JSON.parse(sessionStorage.getItem("customer"));
  }

  createLoginForm() {

    this.loginForm = this.fb.group({
      customerId: ['', [Validators.required ]],
        password: ['', [Validators.required]]
    });
}

createSignUpForm() {
  this.signUpform = this.fb.group({
    customerId: ['', [Validators.required ]],
    contactNumber:['',[]],
    customerName: ['', [Validators.required ]],
     collegeName: ['', [Validators.required ]],

      password: ['', [Validators.required]]
  });
}

login(){
  this.customer=null;
 this.errorMessage=null
 this.successMessage=null
  this.service.login(this.loginForm.value).subscribe(res=>{
    this.customer = res
     sessionStorage.setItem("customer", JSON.stringify(this.customer));
     this.ngOnInit()
     this.router.navigate(['/login']);
   
    
  },err=>{console.log(err)
  this.errorMessage=err.error.message})
}
signUp(){

  this.errorMessage=null
 this.successMessage=null
  this.service.signup(this.signUpform.value).subscribe(res=>{
    console.log(res)
   this.successMessage="User has been registered successfully"
  },err=>{
  
    this.successMessage=err.error.text;
    

    this.errorMessage=err.error.message;
   
    })

}

}
